(function () {
  'use strict';

  const SIZE_PATTERN = /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i;
  const APPLY_DELAY = 450;
  const TRANSLATIONS = {
    "bg": {"dimensions":"Размери","price":"Цена","width":"Ширина","length":"Дължина","from":"От","to":"До","hint":"Размери в сантиметри","other":"Други размери","apply":"Приложи филтрите","noMatch":"Няма подходящи размери в този диапазон. Моля, променете диапазона."},
    "cs": {"dimensions":"Rozměry","price":"Cena","width":"Šířka","length":"Délka","from":"Od","to":"Do","hint":"Rozměry v centimetrech","other":"Další rozměry","apply":"Použít filtry","noMatch":"V tomto rozsahu nejsou žádné odpovídající rozměry. Upravte prosím rozsah."},
    "da": {"dimensions":"Mål","price":"Pris","width":"Bredde","length":"Længde","from":"Fra","to":"Til","hint":"Mål i centimeter","other":"Andre størrelser","apply":"Anvend filtre","noMatch":"Ingen størrelser passer til dette interval. Justér venligst intervallet."},
    "el": {"dimensions":"Διαστάσεις","price":"Τιμή","width":"Πλάτος","length":"Μήκος","from":"Από","to":"Έως","hint":"Διαστάσεις σε εκατοστά","other":"Άλλα μεγέθη","apply":"Εφαρμογή φίλτρων","noMatch":"Δεν υπάρχουν διαστάσεις σε αυτό το εύρος. Προσαρμόστε το εύρος."},
    "et": {"dimensions":"Mõõtmed","price":"Hind","width":"Laius","length":"Pikkus","from":"Alates","to":"Kuni","hint":"Mõõtmed sentimeetrites","other":"Muud suurused","apply":"Rakenda filtrid","noMatch":"Selles vahemikus pole sobivaid mõõtmeid. Palun muuda vahemikku."},
    "fi": {"dimensions":"Mitat","price":"Hinta","width":"Leveys","length":"Pituus","from":"Alkaen","to":"Asti","hint":"Mitat senttimetreinä","other":"Muut koot","apply":"Käytä suodattimia","noMatch":"Tällä välillä ei ole sopivia kokoja. Muuta mittaväliä."},
    "fr": {"dimensions":"Dimensions","price":"Prix","width":"Largeur","length":"Longueur","from":"De","to":"À","hint":"Dimensions en centimètres","other":"Autres dimensions","apply":"Appliquer les filtres","noMatch":"Aucune dimension ne correspond à cette plage. Veuillez ajuster les mesures."},
    "hr": {"dimensions":"Dimenzije","price":"Cijena","width":"Širina","length":"Duljina","from":"Od","to":"Do","hint":"Dimenzije u centimetrima","other":"Ostale veličine","apply":"Primijeni filtre","noMatch":"U ovom rasponu nema odgovarajućih dimenzija. Prilagodite raspon."},
    "hu": {"dimensions":"Méretek","price":"Ár","width":"Szélesség","length":"Hosszúság","from":"Ettől","to":"Eddig","hint":"Méretek centiméterben","other":"További méretek","apply":"Szűrők alkalmazása","noMatch":"Ebben a tartományban nincs megfelelő méret. Módosítsa a tartományt."},
    "ja": {"dimensions":"サイズ","price":"価格","width":"幅","length":"長さ","from":"最小","to":"最大","hint":"寸法（cm）","other":"その他のサイズ","apply":"フィルターを適用","noMatch":"この範囲に一致するサイズはありません。範囲を調整してください。"},
    "lt": {"dimensions":"Matmenys","price":"Kaina","width":"Plotis","length":"Ilgis","from":"Nuo","to":"Iki","hint":"Matmenys centimetrais","other":"Kiti dydžiai","apply":"Taikyti filtrus","noMatch":"Šiame intervale nėra tinkamų matmenų. Pakoreguokite intervalą."},
    "lv": {"dimensions":"Izmēri","price":"Cena","width":"Platums","length":"Garums","from":"No","to":"Līdz","hint":"Izmēri centimetros","other":"Citi izmēri","apply":"Lietot filtrus","noMatch":"Šajā diapazonā nav atbilstošu izmēru. Lūdzu, pielāgojiet diapazonu."},
    "nl": {"dimensions":"Afmetingen","price":"Prijs","width":"Breedte","length":"Lengte","from":"Van","to":"Tot","hint":"Afmetingen in centimeters","other":"Andere maten","apply":"Filters toepassen","noMatch":"Geen maten passen binnen dit bereik. Pas de afmetingen aan."},
    "sl": {"dimensions":"Mere","price":"Cena","width":"Širina","length":"Dolžina","from":"Od","to":"Do","hint":"Mere v centimetrih","other":"Druge velikosti","apply":"Uporabi filtre","noMatch":"V tem razponu ni ustreznih mer. Prilagodite razpon."},
    "zh": {"dimensions":"尺寸","price":"价格","width":"宽度","length":"长度","from":"从","to":"至","hint":"尺寸单位：厘米","other":"其他尺寸","apply":"应用筛选","noMatch":"此范围内没有匹配的尺寸。请调整范围。"},
    de: { dimensions: 'Maße', price: 'Preis', width: 'Breite', length: 'Länge', from: 'Von', to: 'Bis', hint: 'Maße in Zentimetern', other: 'Weitere Maße', apply: 'Filter anwenden', noMatch: 'Keine passenden Maße in diesem Bereich. Bitte ändern Sie den Bereich.' },
    en: { dimensions: 'Dimensions', price: 'Price', width: 'Width', length: 'Length', from: 'From', to: 'To', hint: 'Measurements in centimetres', other: 'Other sizes', apply: 'Apply filters', noMatch: 'No sizes match this range. Please adjust the measurements.' },
    it: { dimensions: 'Misure', price: 'Prezzo', width: 'Larghezza', length: 'Lunghezza', from: 'Da', to: 'A', hint: 'Misure in centimetri', other: 'Altre misure', apply: 'Applica filtri', noMatch: 'Nessuna misura corrisponde a questo intervallo. Modifica le misure.' },
    es: { dimensions: 'Medidas', price: 'Precio', width: 'Ancho', length: 'Largo', from: 'Desde', to: 'Hasta', hint: 'Medidas en centímetros', other: 'Otras medidas', apply: 'Aplicar filtros', noMatch: 'No hay medidas en este intervalo. Ajusta las medidas.' }
  };
  const language = document.documentElement.lang.toLowerCase().split('-')[0];
  const text = TRANSLATIONS[language] || TRANSLATIONS.de;
  let homepagePresetApplied = false;

  function numberFrom(value) {
    return Number(String(value).replace(',', '.'));
  }

  function parseSize(value) {
    const match = String(value).match(SIZE_PATTERN);

    if (!match) {
      return null;
    }

    const width = numberFrom(match[1]);
    const length = numberFrom(match[2]);

    if (!Number.isFinite(width) || !Number.isFinite(length)) {
      return null;
    }

    return { width, length };
  }

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  function updateTrack(rangeElement, minimum, maximum) {
    const span = maximum - minimum || 1;
    const from = Number(rangeElement.querySelector('[data-range-from]').value);
    const to = Number(rangeElement.querySelector('[data-range-to]').value);
    const track = rangeElement.querySelector('.range-group');

    track.style.setProperty('--range-min', `${((from - minimum) / span) * 100}%`);
    track.style.setProperty('--range-max', `${((to - minimum) / span) * 100}%`);
  }

  function rangeMarkup(axis, label, minimum, maximum, selectedMinimum, selectedMaximum) {
    return `
      <fieldset class="wawa-dimension-filter__axis" data-dimension-axis="${axis}">
        <legend>${label}</legend>
        <div class="price-range__range-group range-group" style="--range-min: 0%; --range-max: 100%">
          <input class="range" type="range" min="${minimum}" max="${maximum}" step="1" value="${selectedMinimum}" data-range-from aria-label="${label}: ${text.from}">
          <input class="range" type="range" min="${minimum}" max="${maximum}" step="1" value="${selectedMaximum}" data-range-to aria-label="${label}: ${text.to}">
        </div>
        <div class="wawa-dimension-filter__inputs">
          <label><span>${text.from}</span><span class="wawa-dimension-filter__number"><input type="number" inputmode="numeric" min="${minimum}" max="${maximum}" step="1" value="${selectedMinimum}" data-number-from aria-label="${label}: ${text.from}, cm"><span>cm</span></span></label>
          <span aria-hidden="true">–</span>
          <label><span>${text.to}</span><span class="wawa-dimension-filter__number"><input type="number" inputmode="numeric" min="${minimum}" max="${maximum}" step="1" value="${selectedMaximum}" data-number-to aria-label="${label}: ${text.to}, cm"><span>cm</span></span></label>
        </div>
      </fieldset>`;
  }

  function initialiseGroup(group) {
    if (group.dataset.wawaDimensionReady === 'true') {
      return;
    }

    const checkboxes = Array.from(group.querySelectorAll('input[type="checkbox"]'));
    const sizeCheckboxes = checkboxes.filter((checkbox) => /filter\.v\.option\.size/i.test(checkbox.name));

    if (sizeCheckboxes.length < 2) {
      return;
    }

    const values = sizeCheckboxes.map((checkbox) => ({
      checkbox,
      dimensions: parseSize(checkbox.value || checkbox.id)
    }));
    const rectangularValues = values.filter((item) => item.dimensions);

    if (rectangularValues.length < 2) {
      return;
    }

    const widths = rectangularValues.map((item) => item.dimensions.width);
    const lengths = rectangularValues.map((item) => item.dimensions.length);
    const widthMinimum = Math.floor(Math.min(...widths));
    const widthMaximum = Math.ceil(Math.max(...widths));
    const lengthMinimum = Math.floor(Math.min(...lengths));
    const lengthMaximum = Math.ceil(Math.max(...lengths));
    const activeValues = rectangularValues.filter((item) => item.checkbox.checked);
    const activeWidths = activeValues.map((item) => item.dimensions.width);
    const activeLengths = activeValues.map((item) => item.dimensions.length);
    const selectedWidthMinimum = activeValues.length ? Math.floor(Math.min(...activeWidths)) : widthMinimum;
    const selectedWidthMaximum = activeValues.length ? Math.ceil(Math.max(...activeWidths)) : widthMaximum;
    const selectedLengthMinimum = activeValues.length ? Math.floor(Math.min(...activeLengths)) : lengthMinimum;
    const selectedLengthMaximum = activeValues.length ? Math.ceil(Math.max(...activeLengths)) : lengthMaximum;
    const sourceList = group.querySelector('.collection__filter-checkbox-list');

    if (!sourceList) {
      return;
    }

    const controls = document.createElement('div');
    controls.className = 'wawa-dimension-filter';
    controls.innerHTML = `
      ${rangeMarkup('width', text.width, widthMinimum, widthMaximum, selectedWidthMinimum, selectedWidthMaximum)}
      ${rangeMarkup('length', text.length, lengthMinimum, lengthMaximum, selectedLengthMinimum, selectedLengthMaximum)}
      <p class="wawa-dimension-filter__hint">${text.hint}</p>
      <p data-dimension-error role="alert" hidden>${text.noMatch}</p>
      ${group.closest('#desktop-filters-form') ? `<button type="submit" class="button button--primary" data-dimension-apply>${text.apply}</button>` : ''}`;
    sourceList.before(controls);

    const unparsedItems = values.filter((item) => !item.dimensions);
    values.forEach((item) => {
      const listItem = item.checkbox.closest('li');
      if (listItem) {
        listItem.hidden = Boolean(item.dimensions);
      }
    });

    if (unparsedItems.length) {
      const additionalSizes = document.createElement('details');
      additionalSizes.className = 'wawa-dimension-filter__other';
      additionalSizes.innerHTML = `<summary>${text.other}</summary>`;
      sourceList.before(additionalSizes);
      additionalSizes.append(sourceList);
    } else {
      sourceList.hidden = true;
    }

    const groupButton = group.querySelector('.collection__filter-group-name');
    if (groupButton) {
      const labelContainer = groupButton.querySelector(':scope > div') || groupButton;
      const firstTextNode = Array.from(labelContainer.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      if (firstTextNode) {
        firstTextNode.textContent = text.dimensions;
      }
    }

    let applyTimer;

    function readAxis(axis) {
      const element = controls.querySelector(`[data-dimension-axis="${axis}"]`);
      return {
        element,
        fromRange: element.querySelector('[data-range-from]'),
        toRange: element.querySelector('[data-range-to]'),
        fromNumber: element.querySelector('[data-number-from]'),
        toNumber: element.querySelector('[data-number-to]')
      };
    }

    const widthAxis = readAxis('width');
    const lengthAxis = readAxis('length');

    function synchroniseAxis(axis, changedControl, minimum, maximum) {
      const numeric = changedControl === axis.fromNumber || changedControl === axis.toNumber;
      let from = clamp(Number(numeric ? axis.fromNumber.value : axis.fromRange.value), minimum, maximum);
      let to = clamp(Number(numeric ? axis.toNumber.value : axis.toRange.value), minimum, maximum);

      if (changedControl === axis.fromNumber) {
        from = clamp(Number(axis.fromNumber.value), minimum, maximum);
      } else if (changedControl === axis.toNumber) {
        to = clamp(Number(axis.toNumber.value), minimum, maximum);
      }

      if (from > to) {
        if (changedControl === axis.fromRange || changedControl === axis.fromNumber) {
          from = to;
        } else {
          to = from;
        }
      }

      axis.fromRange.value = from;
      axis.toRange.value = to;
      axis.fromNumber.value = from;
      axis.toNumber.value = to;
      updateTrack(axis.element, minimum, maximum);
    }

    function applySelection(notify = true) {
      const widthFrom = Number(widthAxis.fromRange.value);
      const widthTo = Number(widthAxis.toRange.value);
      const lengthFrom = Number(lengthAxis.fromRange.value);
      const lengthTo = Number(lengthAxis.toRange.value);
      const isFullRange = widthFrom === widthMinimum && widthTo === widthMaximum && lengthFrom === lengthMinimum && lengthTo === lengthMaximum;

      const matches = rectangularValues.filter((item) => item.dimensions.width >= widthFrom && item.dimensions.width <= widthTo && item.dimensions.length >= lengthFrom && item.dimensions.length <= lengthTo);
      const invalid = !isFullRange && matches.length === 0;
      controls.querySelector('[data-dimension-error]').hidden = !invalid;
      widthAxis.fromNumber.setCustomValidity(invalid ? text.noMatch : '');
      if (invalid) return;
      rectangularValues.forEach((item) => {
        item.checkbox.checked = !isFullRange && matches.includes(item);
      });

      const summary = groupButton && groupButton.querySelector('.collection__filter-item-active');
      if (summary) {
        summary.textContent = isFullRange ? '' : `${widthFrom}–${widthTo} × ${lengthFrom}–${lengthTo} cm`;
      }

      const eventTarget = rectangularValues[0].checkbox;
      if (notify) eventTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function queueApply() {
      window.clearTimeout(applyTimer);
      applyTimer = window.setTimeout(applySelection, APPLY_DELAY);
    }

    [widthAxis, lengthAxis].forEach((axis, index) => {
      const minimum = index === 0 ? widthMinimum : lengthMinimum;
      const maximum = index === 0 ? widthMaximum : lengthMaximum;
      [axis.fromRange, axis.toRange].forEach((control) => {
        control.addEventListener('input', () => {
          synchroniseAxis(axis, control, minimum, maximum);
          applySelection(false);
        });
        control.addEventListener('change', queueApply);
      });
      [axis.fromNumber, axis.toNumber].forEach((control) => {
        control.addEventListener('input', () => {
          const from = Number(axis.fromNumber.value), to = Number(axis.toNumber.value);
          if (axis.fromNumber.value !== '' && axis.toNumber.value !== '' && from >= minimum && to <= maximum && from <= to) {
            axis.fromRange.value = from;
            axis.toRange.value = to;
            updateTrack(axis.element, minimum, maximum);
            applySelection(false);
          }
        });
        control.addEventListener('change', () => {
          synchroniseAxis(axis, control, minimum, maximum);
          queueApply();
        });
      });
      updateTrack(axis.element, minimum, maximum);
    });

    if (!homepagePresetApplied) {
      const parameters = new URLSearchParams(window.location.search);
      const requestedWidthFrom = parameters.get('wawa_width_from');
      const requestedWidthTo = parameters.get('wawa_width_to');
      const requestedLengthFrom = parameters.get('wawa_length_from');
      const requestedLengthTo = parameters.get('wawa_length_to');
      const hasHomepagePreset = [requestedWidthFrom, requestedWidthTo, requestedLengthFrom, requestedLengthTo].some((value) => value !== null);

      if (hasHomepagePreset) {
        widthAxis.fromRange.value = clamp(Number(requestedWidthFrom ?? widthMinimum), widthMinimum, widthMaximum);
        widthAxis.toRange.value = clamp(Number(requestedWidthTo ?? widthMaximum), widthMinimum, widthMaximum);
        lengthAxis.fromRange.value = clamp(Number(requestedLengthFrom ?? lengthMinimum), lengthMinimum, lengthMaximum);
        lengthAxis.toRange.value = clamp(Number(requestedLengthTo ?? lengthMaximum), lengthMinimum, lengthMaximum);
        synchroniseAxis(widthAxis, widthAxis.fromRange, widthMinimum, widthMaximum);
        synchroniseAxis(lengthAxis, lengthAxis.fromRange, lengthMinimum, lengthMaximum);
        homepagePresetApplied = true;
        window.setTimeout(applySelection, 0);
      }
    }

    group.dataset.wawaDimensionReady = 'true';
  }

  function hideLegacyDimensionGroups(root) {
    const legacyInputs = root.querySelectorAll([
      'input[name*="filter.p.m.custom.width_cm"]',
      'input[name*="filter.p.m.custom.length_cm"]'
    ].join(','));

    legacyInputs.forEach((input) => {
      const group = input.closest('.collection__filter-group');

      if (group) {
        group.hidden = true;
        group.setAttribute('aria-hidden', 'true');
        group.dataset.wawaLegacyDimensionFilter = 'true';
      }
    });
  }

  function localisePriceGroups(root) {
    root.querySelectorAll('.collection__filter-group').forEach((group) => {
      if (!group.querySelector('input[name^="filter.v.price."]')) {
        return;
      }

      const groupButton = group.querySelector('.collection__filter-group-name');
      const labelContainer = groupButton && (groupButton.querySelector(':scope > div') || groupButton);
      const firstTextNode = labelContainer && Array.from(labelContainer.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());

      if (firstTextNode) {
        firstTextNode.textContent = text.price;
      }
    });
  }

  function initialise(root) {
    hideLegacyDimensionGroups(root);
    localisePriceGroups(root);
    root.querySelectorAll('.collection__filter-group').forEach(initialiseGroup);
    root.querySelectorAll('#mobile-collection-filters .collection-drawer__footer button').forEach((button) => {
      const previewBar = document.getElementById('PBarNextFrameWrapper');
      const previewHeight = previewBar ? previewBar.getBoundingClientRect().height : 0;
      button.parentElement.style.paddingBottom = previewHeight ? `${15 + previewHeight}px` : '';
      button.type = 'submit';
      button.setAttribute('form', 'mobile-collection-filters-form');
      button.removeAttribute('data-action');
      if (button.dataset.wawaApplyReady !== 'true') {
        button.addEventListener('click', (event) => event.stopPropagation());
        button.dataset.wawaApplyReady = 'true';
      }
    });
  }

  function start() {
    initialise(document);
    window.addEventListener('resize', () => initialise(document));
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) {
        initialise(document);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

